<script setup>
import { defineProps } from 'vue';
import animation from "@/assets/animations/loader.json";
defineProps({
  transition: {
    type: Boolean,
    default: false
  }
})
</script>
<template>
  <div :class="['loader', {'loader_transition': transition}]">
    <div class="loader__inner">
      <h2 v-if="!transition">
        Открой праздничное<br/>настроение
      </h2>
      <Vue3Lottie :animationData="animation" :width="52" :height="86"/>
    </div>
    <img :src="require('@/assets/img/logo-white.svg')" alt="" class="loader__logo"/>
  </div>
</template>